import { render, staticRenderFns } from "./TrivestSearchField.vue?vue&type=template&id=5f391c4b&scoped=true&"
import script from "./TrivestSearchField.vue?vue&type=script&lang=ts&"
export * from "./TrivestSearchField.vue?vue&type=script&lang=ts&"
import style0 from "./TrivestSearchField.vue?vue&type=style&index=0&id=5f391c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f391c4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
